import type { DirectiveBinding, ObjectDirective } from "vue";

interface PreventClickElement extends HTMLElement {
    disabled: boolean;
}

const preventClick: ObjectDirective<PreventClickElement, number> = {
    mounted(el: PreventClickElement, binding: DirectiveBinding<number>) {
        el.addEventListener("click", () => {
            if (el.disabled) return;

            el.disabled = true;
            el.classList.add("is-disabled");
            el.classList.add("my-click-disabled"); // loading 样式

            const delay = binding.value || 2000; // 默认2秒

            setTimeout(() => {
                el.disabled = false;
                el.classList.remove("is-disabled");
                el.classList.remove("my-click-disabled");
            }, delay);
        });
    },
};

export default preventClick;
